/* Enhance the shipping progress card after cart section re-renders. */
(function () {
  'use strict';
  if (customElements.get('podz-shipping-progress')) return;
  class PodzShippingProgress extends HTMLElement {
    connectedCallback() { this.update(); }
    update() {
      var subtotal = Number(this.getAttribute('data-cart-cents')) || 0;
      var currency = this.getAttribute('data-currency') || 'CAD';
      var threshold = Number(this.getAttribute('data-threshold-cad-cents')) || 9900;
      var country = this.getAttribute('data-country');
      var rate = 1;
      if (country === 'US' && currency === 'USD') {
        var shopify = window.Shopify && window.Shopify.currency;
        if (!shopify || shopify.active !== 'USD' || !(Number(shopify.rate) > 0)) return;
        rate = Number(shopify.rate);
      } else if (!(country === 'CA' && currency === 'CAD')) {
        return;
      }
      var convertedThreshold = threshold * rate;
      var progress = Math.max(0, Math.min(100, Math.round(subtotal / convertedThreshold * 100)));
      var progressElement = this.querySelector('[role="progressbar"]');
      var fillElement = this.querySelector('.podz-shipping-progress__fill');
      var messageElement = this.querySelector('.podz-shipping-progress__message');
      if (progressElement) progressElement.setAttribute('aria-valuenow', String(progress));
      if (fillElement) fillElement.style.width = progress + '%';
      if (!messageElement) return;
      if (subtotal >= convertedThreshold) {
        messageElement.textContent = "You've unlocked free standard shipping!";
      } else {
        var remaining = Math.max(0, (convertedThreshold - subtotal) / 100);
        var shown = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency',currency:currency}).format(remaining);
        messageElement.textContent = "You're " + (country === 'US' ? 'approximately ' : '') + shown + " away from free standard shipping";
      }
    }
  }
  customElements.define('podz-shipping-progress', PodzShippingProgress);
})();